/**
 * # appName
 * Application name. Should be implemented with the correct name by application modules.
 */
export type AppName = string;
export const AppNameProvider = {
  provide: 'appName',
  useValue: 'core',
};
